/* tslint:disable */
/* eslint-disable */
/**
 * Localization service API
 * Service for localization Origin messages
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SaveLocalizedTextRequest
 */
export interface SaveLocalizedTextRequest {
    /**
     * Localized value
     * @type {string}
     * @memberof SaveLocalizedTextRequest
     */
    value: string;
    /**
     * Scope or name of application of requested localized messages
     * @type {string}
     * @memberof SaveLocalizedTextRequest
     */
    scope?: string;
}

/**
 * Check if a given object implements the SaveLocalizedTextRequest interface.
 */
export function instanceOfSaveLocalizedTextRequest(value: object): boolean {
    if (!('value' in value)) return false;
    return true;
}

export function SaveLocalizedTextRequestFromJSON(json: any): SaveLocalizedTextRequest {
    return SaveLocalizedTextRequestFromJSONTyped(json, false);
}

export function SaveLocalizedTextRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveLocalizedTextRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'scope': json['scope'] == null ? undefined : json['scope'],
    };
}

export function SaveLocalizedTextRequestToJSON(value?: SaveLocalizedTextRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'scope': value['scope'],
    };
}

